import React from 'react';
import './App.scss';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-datepicker/dist/react-datepicker.css';
import { QueryClientProvider, QueryClient } from 'react-query';
import PageRouter from './config/PageRouter';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

function App() : React.ReactElement {
  return (
    <div>
      <QueryClientProvider client={queryClient}>
        <PageRouter />
      </QueryClientProvider>
    </div>
  );
}

export default App;
